import { Fragment, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { cambiarClienteCotizacionFacturas, deleteDetalleVenta, Editarfactura, obtenerDetalleFactura, PostfacturaDetalle, updateDetalleVenta } from '../../api/Factura';
import HeaderComponent from '../../components/HeaderComponent';
import TitleH2Component from '../../components/TitleH2Component';
import TitleH4Component from '../../components/TitleH4Component';
import ParrafoComponent from '../../components/ParrafoComponent';
import InputComponent from '../../components/InputComponent';
import stylegeneral from "../../styles/general.module.scss";
import { BuscarCliente, PostCliente } from '../../api/ApiVenta';
import stylebtn from "../../styles/btn.module.scss";
import AlertComponent from '../../components/AlertComponent';
import { EditarPersona, PostPersona } from '../../api/Empleado';
import styleform from "../../styles/form.module.scss";
import LoaderComponent from '../../components/LoaderComponent';
import ModalGeneralComponent from '../../components/ModalGeneralComponent';
import { Icon } from '@iconify/react/dist/iconify.js';
import SelectComponent from '../../components/SelectComponent';
import { getClases } from '../../api/Clase';
import { FiltrarProducto } from '../../api/Filters';
import { getTipos } from '../../api/Tipo';
import MoneyInputComponent from '../../components/MoneyInputComponent';
import { getTransporte } from '../../api/transporte';
import { abrirPdfVentas } from '../../api/Pdf';
const EditarFacturaPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [currentFactura, setCurrentFactura] = useState([]);
  const [currentDF, setCurrentDF] = useState([]);
  const [control, setcontrol] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [currentPersona, setCurrentPersona] = useState([]);
  const [idCliente, setIdCliente] = useState("");
  const [currentCliente, setCurrentCliente] = useState([]);
  const [mensajealerta, setMensajealerta] = useState("");
  const [alert, setAlert] = useState(false);
  const [showventa, setShowVenta] = useState(false);
  const [optionsclass, setOptionsClass] = useState([]);
  const [selectedOptionClass, setSelectedOptionClass] = useState(null);
  const [selectedOptionType, setSelectedOptionType] = useState(null);
  const [selectedOptionDimension, setSelectedOptionDimension] = useState(null);
  const [dimensionOpcion, setDimensionOpcion] = useState([]);
  const [currentProducto, setCurrentProducto] = useState([]);
  const [optionstype, setOptionstype] = useState([]);
  const [cantidad, setCantidad] = useState("");
  const [productos, setProductos] = useState([]);
  const [showEliminar, setShowEliminar] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalabonos, setTotalAbonos] = useState(0);
  const [descuento, setDescuento] = useState("");
  const [transporte, setTransporte] = useState("")
  const [dataTransporte, setDatTransporte] = useState([]);
  const [transporteID, setTransporteID] = useState("")
  const [pendientes, setPendientes] = useState(false);
  const navigate = useNavigate();
  const [formDataPersona, setFormDataPersona] = useState({
    cedula: "",
    nombre: "",
    apellido: "",
    direccion: "",
    celular: "",
  });

  const [formDataFactura, setFormDataFactura] = useState({
    transporte: "",
    nombre_conductor: "",
    celular_conductor: "",
    quien_recibe: "",
    direccion_envio: "",
  });

  const [checkboxes, setCheckboxes] = useState({
    isChecked: false,
    isCheckedDescuento: false,
    isCheckedpago: false,
    isCheckedPendiente: false,
    istransporte: false,
    debeActualizarCliente: false,
    cambiarCliente: false,
  });

  // Manejar el cambio en el input
  const handleInputChangePersona = (event) => {
    const { name, value } = event.target;
    setFormDataPersona({
      ...formDataPersona,
      [name]: value,
    });
  };

  const handleInputChangeFactura = (event) => {
    const { name, value } = event.target;
    setFormDataFactura({
      ...formDataFactura,
      [name]: value,
    });
  };

  // este es el metodo para sacar el valor del check
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));

    if (id === "isCheckedDescuento" && !checked) {
      setDescuento(0);
    }
  }

  // Manejar el cambio en el input
  const handleInputChange = (event) => {
    setCantidad(event.target.value);
  };
  const handleCloseVenta = () => {
    setShowVenta(false);
  };

  // Manejar el cambio en el input para los descuentos
  const handleInputChangedescuento = (event) => {
    setDescuento(event.target.value);
  };

  // Manejar el cambio en el input para los transporte
  const handleInputChangeTransporte = (event) => {
    setTransporte(event.target.value);
  };


  const fetchFactura = async () => {
    setLoading(true);
    try {
      const factura = await obtenerDetalleFactura(id);
      const detalles = factura?.data?.DetalleFacturas;
      const dataAbonos = factura?.data?.Abonos;
      setCurrentFactura(factura?.data);
      setCurrentDF(detalles);
      const cliente = factura?.data?.Cliente?.Persona;
      setCurrentPersona(cliente);
      setFormDataPersona({
        cedula: cliente?.cedula,
        nombre: cliente?.nombre,
        apellido: cliente?.apellido,
        direccion: cliente?.direccion,
        celular: cliente?.celular,
      })

      setFormDataFactura({
        transporte: factura?.data?.transporte,
        nombre_conductor: factura?.data?.nombre_conductor,
        celular_conductor: factura?.data?.celular_conductor,
        quien_recibe: factura?.data?.quien_recibe,
        direccion_envio: factura?.data?.direccion,
      })

      //Metodo para sumar los subtotales de la venta 
      const subtotalSuma = detalles?.reduce((subtotal, item) => {
        return subtotal + Number(item.valorTotalPorProducto);
      }, 0);

      const abonosSuma = dataAbonos?.reduce((acc, item) => {
        return acc + Number(item.monto);
      }, 0);
      const descuentoFactura = Number(factura?.data?.descuento || 0);
      const transporteFactura = Number(factura?.data?.transporte || 0)

      //Logica para calcular si hay pendientes por entregar 
      const pendientes = detalles.some(
        item => item.pendientePorEntregar > 0
      );

      setPendientes(pendientes)
      setSubTotal(subtotalSuma);
      setTransporte(transporteFactura)
      setTotal(subtotalSuma);
      setDescuento(descuentoFactura);
      setTotalAbonos(abonosSuma)

      if (descuentoFactura > 0) {
        setCheckboxes(prev => ({
          ...prev,
          isCheckedDescuento: true
        }));
      }

      if (transporteFactura > 0) {
        setCheckboxes(prev => ({
          ...prev,
          istransporte: true
        }));
      }

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (id) {
      fetchFactura();
    }
  }, [id]);

  // metodo para consultar la cc
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      consultarCedula();
    }
  };

  // metodo para verificar el cliente antes de registrar la compra
  const verificarCliente = () => {
    consultarCedula();
  };
  const consultarCedula = async () => {
    try {
      const res = await BuscarCliente(formDataPersona.cedula);
      setcontrol(res.success);
      if (res.success) {
        setFormDataPersona({
          cedula: res?.data?.cedula,
          nombre: res?.data?.nombre,
          apellido: res?.data?.apellido,
          direccion: res?.data?.direccion,
          celular: res?.data?.celular,
        });
        setCurrentPersona(res?.data);
        setIdCliente(res?.data?.Clientes[0]?.id);
        setCurrentCliente(res?.data?.Clientes);
        localStorage.setItem("cliente", JSON.stringify(res?.data));
      } else {
        /*setIdCliente('')*/

        setMensaje(res.msg);
        setFormDataPersona({
          cedula: formDataPersona.cedula,
          nombre: "",
          apellido: "",
          direccion: "",
          celular: "",
        });
      }

      /*setcontrol(res.success)*/
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  // este metodo es para cambiar el cliente de la factura
  const crearCliente = async (cambiarCliente = false) => {
    if (!control || control === false) {
      const resP = await PostPersona(formDataPersona);
      if (resP.success) {
        const rescliente = await PostCliente(resP.data.idP);
        setIdCliente(rescliente?.data?.id);
        return rescliente?.data?.id; // ✅ devolvemos el ID
      }
    } else if (currentCliente.length === 0) {
      const rescliente = await PostCliente(currentPersona?.idP);
      setIdCliente(rescliente?.data?.id);
      if (cambiarCliente) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return rescliente?.data?.id; // ✅ devolvemos el ID
    } else {
      // Si ya existe cliente actual, devolvemos su ID directamente
      if (cambiarCliente) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return currentCliente[0]?.id;
    }
  };

  useEffect(() => {
    getClases()
      .then((response) => {
        const formattedOptions = response?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionsClass(formattedOptions);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  useEffect(() => {
    getTipos()
      .then((response) => {
        const formattedOptions = response?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionstype(formattedOptions);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  //metodo de filtro
  useEffect(() => {
    filtroproducto();
  }, [selectedOptionClass, selectedOptionType, selectedOptionDimension]);

  const filtroproducto = () => {
    if (!selectedOptionClass && !selectedOptionType && !selectedOptionDimension) {
      // No hacer nada si no hay filtros
      setProductos([]);
      return;
    }

    FiltrarProducto({
      idClase: selectedOptionClass,
      idTipo: selectedOptionType,
      dimension: selectedOptionDimension,
    })
      .then((response) => {
        const formattedOptionsDimension = response?.data?.map((item) => ({
          value: item.dimension,
          label: item.dimension,
        }));

        setDimensionOpcion(formattedOptionsDimension);
        setProductos(response?.data ?? []);
      })
      .catch((error) => console.error(error));
  };

  const editarFactura = async () => {
    setShowVenta(true);
    setLoading(true);
    try {

      //logica para actualizar a la persona 
      if (checkboxes.debeActualizarCliente) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }

      //Logica para cambiar de cliente a la factura 
      if (checkboxes.cambiarCliente) {
        const clienteId = await crearCliente(checkboxes.cambiarCliente);
        await cambiarClienteCotizacionFacturas(id, clienteId);

      }

      let estado = currentFactura?.estado;
      let totalFinal = (subTotal + transporte) - descuento;
      if (totalFinal > totalabonos && Number(currentFactura?.financiado > 0)) {
        estado = 1;
      } else if (pendientes) {
        estado = 2;
      } else {
        estado = 0;
      }

      await Editarfactura(
        currentFactura?.id,
        currentFactura?.User?.id,
        estado,
        subTotal,
        currentFactura?.fechaDePago,
        Number(descuento),
        currentFactura?.financiado,
        total,
        Number(transporte),
        currentFactura?.tipo,
        formDataFactura.quien_recibe,
        formDataFactura.direccion_envio,
        formDataFactura?.nombre_conductor,
        formDataFactura?.celular_conductor,
        currentFactura?.fecha_creacion

      );

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const aggProducto = async () => {
    const resultado = currentDF.filter(item => item.idProducto === currentProducto?.id);
    const existe = resultado.length > 0;

    if (
      cantidad === "" || cantidad <= 0
    ) {
      setMensaje("Debe agregar una cantidad");
    } else if (currentProducto.length === 0) {
      setMensaje("Debe seleccionar un producto");
    } else if (existe) {
      setMensaje('El producto que intenta agregar ya fue retirado previamente del mismo bloque y puesto. Por favor valide la información antes de continuar.')
    } else {
      let isventa = false;
      setLoading(true);
      const nuevoProducto = {
        id: currentProducto?.id,
        clase: currentProducto?.Clase?.name,
        tipo: currentProducto?.Tipo?.name,
        dimension: currentProducto?.dimension,
        cantidad: 0,
        valorTotalPorProducto: Number(cantidad) * Number(currentProducto?.precioVenta),
        valorPorUnidad: Number(currentProducto?.precioVenta),
        pendientePorEntregar: Number(cantidad),
      };
      const resFD = await PostfacturaDetalle(
        isventa,
        currentFactura.id,
        [nuevoProducto]
      );
      if (resFD?.success) {
        setAlert(true)
        setMensajealerta('Se agrego un nuevo porducto');
        fetchFactura();
        setLoading(false);
      }

    }

    setTimeout(() => {
      setMensaje('')
      setAlert(false)
    }, 3000)
  }
  const getEstadoProducto = (item) => {
    if (item?.pendientePorEntregar === 0) {
      return {
        texto: "Entregado",
        clase: "bg-success text-white"
      };
    }

    if (item?.pendientePorEntregar > item?.Producto?.cantidad) {
      return {
        texto: `Agotados en B${item?.Producto?.Puesto?.Bloque?.name}/P${item?.Producto?.Puesto?.numero}`,
        clase: "bg-danger text-white"
      };
    }

    return {
      texto: "Disponibles",
      clase: "bg-warning text-white"
    };
  };

  // Metodos para el popup de eliminar
  const handleCloseEliminar = () => setShowEliminar(false);
  const handleShowEliminar = (item) => {
    setShowEliminar(true);
    setCurrentProducto(item);
  };

  // metodo para eliminar del carrito de compra
  const eliminarItem = async () => {

    try {
      const resVD = await deleteDetalleVenta(currentProducto.id);
      if (resVD?.success) {
        handleCloseEliminar();
        fetchFactura();
        setAlert(true)
        setMensajealerta(resVD.message)
      }

    } catch (error) {
      console.log(error);
    }

    setTimeout(() => {
      setAlert(false)

    }, 3000)

  };

  // Metodos para el popup de aditar
  const handleCloseEditar = () => {
    setShowEditar(false);
    setCantidad("")
  }
  const handleShowEditar = (item) => {
    setShowEditar(true);
    setCurrentProducto(item);
    setCantidad(item?.pendientePorEntregar);
  };

  const actualizarventa = async () => {
    try {
      const updateProducto = {
        pendientePorEntregar: Number(cantidad),
        idProducto: currentProducto?.idProducto,
        cantidad: currentProducto?.cantidad,
        valorPorUnidad: Number(currentProducto?.Producto?.precioVenta),
        valorTotalPorProducto: (Number(cantidad) + Number(currentProducto?.cantidad)) * Number(currentProducto?.Producto?.precioVenta)
      };
      const resUpdate = await updateDetalleVenta(currentProducto?.id, updateProducto);
      if (resUpdate?.success) {
        setAlert(true)
        setMensajealerta(resUpdate?.msg);
        fetchFactura();
        handleCloseEditar()
      }

    } catch (error) {
      console.log(error)
    }

    setTimeout(() => {
      setAlert(false)
    }, 3000)
  }


  //Metodo para obtener los transportes
  const obtenerdatosTransporte = (idSeleccionado) => {
    const transporteEncontrado = dataTransporte.find(
      (item) => item.id === idSeleccionado
    );

    if (!transporteEncontrado) return null;

    return {
      nombre: transporteEncontrado.Persona?.nombre,
      apellido: transporteEncontrado.Persona?.apellido,
      celular: transporteEncontrado.Persona?.celular,

    };
  };


  //Metodo para traer todo los transporte 
  const fetchTransporte = async (filters = {}) => {
    try {
      const res = await getTransporte(filters);
      setDatTransporte(res?.data);
    } catch (error) {
      console.error('Error al obtener los transportes:', error);
    }
  };

  useEffect(() => {
    fetchTransporte();
  }, []);

  const generarPdf = async () => {
    await abrirPdfVentas(currentFactura?.id);
     navigate(currentFactura?.tipo === "venta" ? '/factura' : '/ver_cotizaciones');
  }

  return (
    <Fragment>

      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4 text-uppercase">
          EDICION DE LA {currentFactura?.tipo}
        </TitleH2Component>
        <Link
          to={`/carrito/${currentFactura?.id}`}
          className={`${stylebtn.btn} ${stylebtn.primary} link me-3`}

        >
          DESPACHAR
        </Link>
      </HeaderComponent>

      <div className='conatiner-global pt-3 mb-5'>
        <section>
          <form>
            <div className={`${stylegeneral.containerFormCotiza} mb-5`}>
              <div className={`container`}>

                <section className="border border-dark rounded p-3">
                  <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                    INFORMACION DEL COMPRADOR
                  </TitleH4Component>
                  <div
                    className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                  >
                    <input
                      className=" me-2"
                      type="checkbox"
                      value=""
                      id="debeActualizarCliente"
                      checked={checkboxes.debeActualizarCliente}
                      onChange={handleCheckboxChange}
                    />
                    <label className="color-madera fw700" htmlFor="recorddat">
                      Actualizar información cliente
                    </label>
                  </div>

                  {currentFactura?.tipo === "cotizacion" && <div
                    className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                  >
                    <input
                      className=" me-2"
                      type="checkbox"
                      value=""
                      id="cambiarCliente"
                      checked={checkboxes.cambiarCliente}
                      onChange={handleCheckboxChange}
                    />
                    <label className="color-madera fw700" htmlFor="recorddat">
                      Cambiar cliente
                    </label>
                  </div>}
                  <div className="row gy-3">
                    <div className="col-12 col-md-6 col-xl-3">
                      <label htmlFor="cedula" className="fw600 WorkSans color-madera">Documento*</label>
                      <input
                        type="text"
                        htmlFor="cudula"
                        className="form-control fw600 WorkSans"
                        placeholder="Ingrese la cc"
                        name="cedula"
                        value={formDataPersona.cedula}
                        onChange={handleInputChangePersona}
                        onKeyDown={handleKeyDown}
                      />
                      <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
                        {mensaje}
                      </ParrafoComponent>
                    </div>
                    {checkboxes.cambiarCliente && <div className="col-12 col-md-9  ">
                      <button
                        type="button"
                        className={` btn ${stylebtn.btn} ${stylebtn.primary}`}
                        onClick={verificarCliente}
                      >
                        Verificar cliente
                      </button>
                    </div>}
                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Nombre*"
                        placeholder="Nombre:"
                        styleLabel="fw600 WorkSans"
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.nombre}
                        name="nombre"
                        onChange={handleInputChangePersona}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Apellidos*"
                        placeholder="Primer Apellido:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.apellido}
                        name="apellido"
                        onChange={handleInputChangePersona}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Direccion"
                        placeholder="Direccion:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.direccion}
                        name="direccion"
                        onChange={handleInputChangePersona}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Celular"
                        placeholder="Celular:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.celular}
                        name="celular"
                        onChange={handleInputChangePersona}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Quien recibe"
                        placeholder="Quien recibe:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataFactura.quien_recibe}
                        name="quien_recibe"
                        onChange={handleInputChangeFactura}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Direccion de envio"
                        placeholder="Direccion de envio:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataFactura.direccion_envio}
                        name="direccion_envio"
                        onChange={handleInputChangeFactura}
                      />
                    </div>
                  </div>
                </section>
              </div>

            </div>
          </form>
        </section>

        <section>
          <div className="container-fluid">
            <section className="mb-1 border border-dark rounded p-2">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-4">
                REGISTRAR PRODUCTO
              </TitleH4Component>
              <div className="row gy-3">
                <div className="col-12 col-md-6 col-xl-3 ">
                  <SelectComponent
                    label="Clase de madera"
                    styleLabel="color-madera fw600"
                    /*options={options}*/
                    customPlaceholder="Clase"
                    options={optionsclass}
                    name="clase"
                    value={selectedOptionClass}
                    capOpcions={setSelectedOptionClass}
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <SelectComponent
                    label="Tipo de madera"
                    styleLabel="color-madera fw600"
                    /*options={options}*/
                    customPlaceholder="tipo"
                    options={optionstype}
                    name="tipo"
                    value={selectedOptionType}
                    capOpcions={setSelectedOptionType}
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <SelectComponent
                    label="Dimension"
                    styleLabel="color-madera fw600"
                    /*options={options}*/
                    customPlaceholder="dimension"
                    options={dimensionOpcion}
                    name="dimension"
                    value={selectedOptionDimension}
                    capOpcions={setSelectedOptionDimension}
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Cantidad*"
                    placeholder="Cant."
                    styleLabel="fw600 WorkSans"
                    styleGroup=""
                    htmlFor="bloque"
                    type="number"
                    name="cantidad"
                    value={cantidad}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

            </section>

            <section className="mb-1 border border-dark rounded p-2 mt-4">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-4">
                LISTA DE PRODUCTOS
              </TitleH4Component>
              <div className="row gy-3">
                {productos.length > 0 ? <div className={`col-12 ${stylegeneral.scrollLista}`}>
                  <div className='row gy-3'>
                    {productos.map((item) => {
                      return (
                        <div className={`col-12 col-lg-6 col-xxl-4`} key={item.id}>
                          <div className="form-check" >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="productoRadio"
                              id={`producto-${item.id}`}
                              checked={currentProducto?.id === item.id}
                              onChange={() => setCurrentProducto(item)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`producto-${item.id}`}
                            >
                              B{item?.Puesto?.Bloque?.name}/P{item?.Puesto?.numero} - {item?.Clase?.name} - {item?.Tipo?.name} - {item?.dimension} - {item?.cantidad} Disponibles
                            </label>
                          </div>
                        </div>

                      );
                    })}
                  </div>

                </div> : <div className='col-12'><ParrafoComponent styleGroup="text-center color-medera fw400 WorkSans mb-2">
                  Lista vacia
                </ParrafoComponent></div>}

                <div className="col-12  my-3 d-flex  justify-content-end">
                  <button
                    type="button"
                    className={`${stylebtn.btn} ${stylebtn.primary} `}
                    onClick={aggProducto}
                    disabled={loading ? true : false}
                  >
                    AGREGAR
                  </button>
                </div>
              </div>
            </section>
            <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
              {mensaje}
            </ParrafoComponent>
          </div>
        </section>

        <section>
          <ParrafoComponent styleGroup=" fw400 WorkSans mb-2">
            Precio del producto :{Number(currentProducto?.precioVenta || 0).toLocaleString('ES-es')} / total: {(Number(cantidad) * Number(currentProducto?.precioVenta || 0)).toLocaleString('ES-es')}
          </ParrafoComponent>
          <div className="table-responsive mt-4">
            <table className="table table-bordered tableGeneral">
              <thead>
                <tr>
                  <th scope="col" className="color-madera">
                    Cantidad
                  </th>
                  {currentFactura?.tipo === 'venta' && <th scope="col" className="color-madera">
                    Pendientes
                  </th>}
                  {currentFactura?.tipo === 'venta' && <th scope="col" className="color-madera">
                    Entregados
                  </th>}
                  <th scope="col" className="color-madera">
                    Descripción
                  </th>
                  <th scope="col" className="color-madera">
                    Valor por Unidad
                  </th>
                  <th scope="col" className="color-madera">
                    Valor Total
                  </th>

                  <th scope="col" className="color-madera">
                    Estado
                  </th>
                  <th scope="col" className="color-madera">
                    Opciones
                  </th>
                </tr>
              </thead>
              {currentDF && currentDF.length > 0 ? <tbody>
                {currentDF.map((item, index) => {
                  return (
                    <tr key={index}>
                      <th>{item?.cantidad + item?.pendientePorEntregar}</th>
                      {currentFactura?.tipo === 'venta' && <th>{item?.pendientePorEntregar}</th>}
                      {currentFactura?.tipo === 'venta' && <th>{item?.cantidad}</th>}
                      <td>
                        {item?.Producto?.Tipo?.name} {item?.Producto?.Clase?.name} {item?.Producto?.dimension}
                      </td>
                      <td>
                        ${Number(item?.valorPorUnidad).toLocaleString("es-ES")}
                        {currentFactura?.tipo === 'cotizacion' && Number(item?.valorPorUnidad) !== Number(item?.Producto?.precioVenta) && <ParrafoComponent styleGroup=" color-danger py-1  fw400 WorkSans mb-2">
                          Precio actualizado: {Number(item?.Producto?.precioVenta).toLocaleString('ES-es')}
                        </ParrafoComponent>}
                      </td>
                      <td>
                        $
                        {Number(item?.valorTotalPorProducto).toLocaleString(
                          "es-ES"
                        )}
                      </td>
                      <td className={getEstadoProducto(item).clase}>
                        {getEstadoProducto(item).texto}
                      </td>
                      <td className='d-flex '>
                        <button
                          className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                          onClick={() => handleShowEditar(item)}
                        >
                          <Icon
                            className={`color-dark`}
                            icon="raphael:edit"
                          />
                        </button>
                        <button
                          className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                          onClick={() => handleShowEliminar(item)}
                        >
                          <Icon icon="majesticons:delete-bin" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody> :
                <tbody><tr><td colSpan={7} className='text-center'>SIN PRODUCTOS</td></tr></tbody>}
              <tfoot>
                <tr>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={currentFactura?.tipo === 'venta' ? '6' : '4'}></td>
                  <td className="text-right">SUBTOTAL</td>
                  <td>$ {Number(subTotal).toLocaleString("es-ES")}</td>
                </tr>
                <tr>
                  <td colSpan={currentFactura?.tipo === 'venta' ? '6' : '4'}></td>
                  <td className="text-right">DESCUENTO</td>
                  <td>
                    ${" "}
                    {Number(
                      checkboxes.isCheckedDescuento ? descuento : 0
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
                <tr>
                  <td colSpan={currentFactura?.tipo === 'venta' ? '6' : '4'}></td>
                  <td className="text-right">TRANSPORTE</td>
                  <td>
                    ${" "}
                    {Number(
                      checkboxes.istransporte ? transporte : 0
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
                <tr>
                  <td colSpan={currentFactura?.tipo === 'venta' ? '6' : '4'}></td>
                  <td className="text-right">PENDIENTE DE PAGO</td>
                  <td>
                    $
                    {currentFactura?.financiado > 0 ? Number(
                      (subTotal - descuento) + Number(transporte) - totalabonos
                    ).toLocaleString("es-ES") : 0}
                  </td>
                </tr>
                <tr className="d-none">
                  <td colSpan={currentFactura?.tipo === 'venta' ? '6' : '4'}></td>
                  <td className="text-right">PENDIENTE POR ENTREGA</td>
                  <td>80</td>
                </tr>
                <tr>
                  <td colSpan={currentFactura?.tipo === 'venta' ? '6' : '4'}></td>
                  <td className="text-right">TOTAL</td>
                  <td
                    style={{
                      backgroundColor: "lightgreen",
                      fontWeight: "bold",
                    }}
                  >
                    ${" "}
                    {(
                      Number(subTotal) +
                      Number(transporte) -
                      Number(descuento)
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </section>
        <section>
          <form action="">
            <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
              {mensaje}
            </ParrafoComponent>

            <div className="d-md-flex justify-content-between align-items-end mt-5 ">
              <div className="">
                <div className="mb-1">
                  <input
                    className=" me-2"
                    type="checkbox"
                    value=""
                    id="isCheckedDescuento"
                    checked={checkboxes.isCheckedDescuento}
                    onChange={handleCheckboxChange}
                  />

                  <label className="color-dark  fw700 me-2" htmlFor="recorddat">
                    Descuento
                  </label>
                </div>

                {checkboxes.isCheckedDescuento && (
                  <div className="">
                    <MoneyInputComponent
                      placeholder="Cant."
                      styleLabel="fw600 WorkSans"
                      styleGroup="mt-2  mb-2"
                      htmlFor="descuento"
                      type="number"
                      name="descuento"
                      value={descuento}
                      onChange={handleInputChangedescuento}
                    />
                  </div>
                )}

                <div className="mb-1">
                  <input
                    className=" me-2"
                    type="checkbox"
                    value=""
                    id="istransporte"
                    checked={checkboxes.istransporte}
                    onChange={handleCheckboxChange}
                  />
                  <label className="color-dark  fw700 me-2" htmlFor="recorddat">
                    Transporte
                  </label>
                </div>

                {checkboxes.istransporte && (
                  <div>
                    <MoneyInputComponent
                      label="Costo"
                      placeholder="Cant."
                      styleLabel="fw600 WorkSans"
                      styleGroup="mt-2  mb-2"
                      htmlFor="transporte"
                      type="number"
                      name="transporte"
                      value={transporte}
                      onChange={handleInputChangeTransporte}
                    />

                    <SelectComponent
                      label="Transporte"
                      styleGroup={`${stylegeneral.wselect}`}
                      styleLabel="fw600 WorkSans color-madera"
                      options={dataTransporte.map((transporte) => ({
                        value: transporte.id,
                        label: transporte?.Persona?.nombre + ' ' + transporte?.Persona?.apellido
                      }
                      ))}

                      capOpcions={(v) => {
                        setTransporteID(v);
                        const datos = obtenerdatosTransporte(v);

                        if (datos) {
                          setFormDataFactura({
                            nombre_conductor: `${datos?.nombre} ${datos.apellido}`,
                            celular_conductor: datos.celular
                          })
                        }
                      }}
                      customPlaceholder="Seleccionar"

                      name="transporte"
                      value={dataTransporte.find(o => o.value == transporteID) || null}

                      isClearable
                    />
                    {formDataFactura.nombre_conductor && <ParrafoComponent styleGroup=" color-madera fw400 WorkSans my-2">
                      Nombre: {formDataFactura.nombre_conductor}
                    </ParrafoComponent>}
                    {formDataFactura?.celular_conductor && <ParrafoComponent styleGroup=" color-madera fw400 WorkSans mb-2">
                      Celular: {formDataFactura?.celular_conductor}
                    </ParrafoComponent>}

                  </div>
                )

                }
              </div>
            </div>
          </form>
        </section>

        <section>
          <div className="col d-flex justify-content-end gap-4">
            <button
              type="button"
              className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
              onClick={editarFactura}
            >
              {'Actualizar'}
            </button>
          </div>
        </section>


        <section>
          <ModalGeneralComponent
            ModalHeader={false}
            titulo="Información del cliente"
            styleGroup={`d-flex align-items-center modal-general `}
            styleBody={`${"bg-gris-modal "}`}
            styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
            show={showventa}
            handleClose={handleCloseVenta}
          >
            {loading ? (
              <LoaderComponent styleGroup="mt-5" />
            ) : (
              <div>
                <div className="d-flex justify-content-end mb-0 align-items-center mb-3">
                  <Link
                    to={`/carrito/${currentFactura?.id}`} // Deshabilita el enlace si la factura está cerrada
                    className={`${stylebtn.btn} ${stylebtn.primary} link me-3`}

                  >
                    DESPACHAR
                  </Link>
                  <button
                    type='button'
                    //to={`/generarfactura/${currentFactura?.id}`}
                    onClick={generarPdf}
                    className={`${stylebtn.btn} ${stylebtn.primary}`}
                  >
                    GENERAR FACTURA
                  </button>
                  <button
                    type="button"
                    className={`btn ${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                    onClick={handleCloseVenta}
                  >
                    <Icon icon="mdi:close-thick" />
                  </button>
                </div>
                <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
                  La {currentFactura?.tipo} se actualizó correctamente
                </TitleH2Component>

              </div>
            )}
          </ModalGeneralComponent>
        </section>

        {/** modal eliminar un producto del carrito **/}
        <section>
          <ModalGeneralComponent
            styleGroup="d-flex align-items-center modal-general "
            styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
            show={showEliminar}
            handleClose={handleCloseEliminar}
          >
            <form action="">
              <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`¿Seguro que quiere eliminar este producto? OJO se eliminará directamente de la factura en tiempo real`}</TitleH2Component>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  onClick={handleCloseEliminar}
                  className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={eliminarItem}
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                >
                  SI
                </button>
              </div>
            </form>
          </ModalGeneralComponent>
        </section>

        {/** modal editar la cantidad de la venta*/}
        <section>
          <ModalGeneralComponent
            ModalHeader
            titulo="Editar cantidad de la venta"
            styleGroup={`d-flex align-items-center modal-general `}
            styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
            show={showEditar}
            handleClose={handleCloseEditar}
          >
            {loading ? (
              <LoaderComponent styleGroup="mt-5" />
            ) : (<form action="">
              <div className="container">
                <div className="row">

                  <div className="col-12">
                    <InputComponent
                      label="Cantidad"
                      placeholder="Ingerse producto"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="number"
                      name="cantidad"
                      value={cantidad}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-12">
                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2">
                      Precio del producto : {Number(currentProducto?.Producto?.precioVenta).toLocaleString('ES-es')}
                    </ParrafoComponent>

                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2">
                      Total : {(Number(currentProducto?.Producto?.precioVenta) * Number(cantidad)).toLocaleString('ES-es')}
                    </ParrafoComponent>

                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2">
                      Salida productos B{currentProducto?.Producto?.Puesto?.Bloque?.name}/P{currentProducto?.Producto?.Puesto?.numero} : {currentProducto?.Producto?.cantidad} Disponibles
                    </ParrafoComponent>
                  </div>

                  {currentFactura.tipo === 'venta' && Number(currentProducto.valorPorUnidad) !== Number(currentProducto?.Producto?.precioVenta) && <div className="col-12">
                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2 color-danger">
                      ⚠ Advertencia
                    </ParrafoComponent>

                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2 color-danger">
                      El precio de este producto ha sido actualizado.
                    </ParrafoComponent>

                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2 color-danger">
                      Antes: ${Number(currentProducto.valorPorUnidad).toLocaleString('ES-es')} <br />
                      Ahora: ${Number(currentProducto?.Producto?.precioVenta).toLocaleString('ES-es')}
                    </ParrafoComponent>

                    <ParrafoComponent styleGroup=" fw400 WorkSans mb-2 color-danger">
                      Se recomienda generar una nueva factura para evitar inconsistencias en el inventario y en los registros contables.
                    </ParrafoComponent>

                  </div>}

                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  onClick={handleCloseEditar}
                  className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                  onClick={actualizarventa}
                  disabled={currentFactura.tipo === 'venta' && Number(currentProducto.valorPorUnidad) !== Number(currentProducto?.Producto?.precioVenta)}
                >
                  Continuar
                </button>
              </div>
            </form>)}
          </ModalGeneralComponent>
        </section>

      </div>
    </Fragment>
  )
}
export default EditarFacturaPage;